import './bootstrap';
import { createApp } from 'vue';
import { createVuetify } from 'vuetify';
import * as directives from 'vuetify/directives';
import * as components from 'vuetify/components';
const vuetify = createVuetify({ components, directives });
import 'vuetify/dist/vuetify.min.css';
import '@mdi/font/css/materialdesignicons.css'

import HeaderComponent from './components/HeaderComponent.vue';
// import permissions from "./Permissions.js";

window.addEventListener('load', function() {
    const base = {
        components: {
            HeaderComponent,
        },
    };

    const app = createApp(base);
    app.use(vuetify);
    // app.mixin(permissions);
    app.mount('#app');
})